import React from "react";
import "./Education.css";

const Education = () => (
  <section className="education-section">
    <h2>🎓 Diplômes et Formations</h2>
    <ul className="education-list">
      <li>
        <strong>Baccalauréat Série Gestion (G2)</strong>
        <span className="edu-details">
          — 2007-2008, Lycée Technique Ampefiloha <br />
          <span className="edu-argument">
            Ce diplôme m’a apporté une solide culture en gestion, comptabilité
            et organisation, des bases précieuses pour comprendre les enjeux
            métiers de mes clients et piloter des projets digitaux avec rigueur.
          </span>
        </span>
      </li>
      <li>
        <strong>Cours en ligne en développement web</strong>
        <span className="edu-details">
          — Depuis 2015 (Coursera, Elephorm, Udemy, OpenClassrooms…) <br />
          <span className="edu-argument">
            Je me forme en continu sur les dernières technologies web (React,
            MERN, Odoo, SEO, sécurité…) grâce à des plateformes reconnues, pour
            garantir à mes clients des solutions toujours actuelles et
            performantes.
          </span>
        </span>
      </li>
      <li>
        <strong>Veille technologique et auto-formation</strong>
        <span className="edu-details">
          — Suivi régulier des tendances web, ERP (Odoo, Zoho), outils
          no-code/low-code <br />
          <span className="edu-argument">
            Je consacre chaque semaine du temps à la veille, aux tests de
            nouveaux outils et à l’expérimentation, afin d’anticiper les
            évolutions du marché et de proposer des solutions innovantes.
          </span>
        </span>
      </li>
      <li>
        <strong>Certificats & micro-formations spécialisées</strong>
        <span className="edu-details">
          — WordPress, Prestashop, Odoo, SEO, sécurité web <br />
          <span className="edu-argument">
            J’ai validé plusieurs micro-certifications et suivis des modules
            experts pour approfondir des compétences clés, en particulier sur la
            création de thèmes WordPress, l’intégration Odoo, et l’optimisation
            SEO.
          </span>
        </span>
      </li>
      <li>
        <strong>Participation à des webinaires & conférences</strong>
        <span className="edu-details">
          — Communautés tech, événements en ligne francophones et internationaux{" "}
          <br />
          <span className="edu-argument">
            Je participe régulièrement à des événements pour échanger avec
            d’autres professionnels, partager les bonnes pratiques et rester à
            la pointe des innovations du secteur.
          </span>
        </span>
      </li>
    </ul>
    <div className="education-note">
      <span role="img" aria-label="lightbulb">
        💡
      </span>
      <span>
        Passionné par l’apprentissage continu, je m’engage à toujours proposer à
        mes clients des solutions innovantes, fiables et adaptées à leurs
        enjeux.
      </span>
    </div>
  </section>
);

export default Education;
